var CommResultsList = React.createClass({
  propTypes: {
    hits: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
  },
  render() {
    if (this.props.hits.length == 0) {
      return <span />
    }

    return (
      <ul className="solution-list">
        {this.props.hits.map(hit => <CommResultItem key={hit.discussion.id} hit={hit} {...this.props} />)}
      </ul>
    )
  }
});